// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1enjF","wrapper-nopadding":"wrapper-nopadding__3UO3c","loading":"loading__xK5pr","error":"error__2reP-","table-loading":"table-loading__1QCOn","empty-val":"empty-val__2yNew","panelheader-tools":"panelheader-tools__2HuxV","propsPanels":"propsPanels__1_8jg","new":"new__6pQaF","marginLm":"marginLm__hzQYj","marginRm":"marginRm__T64hN","fullWidth":"fullWidth__1oQzC","fullHeight":"fullHeight__2yU8l","noData":"noData__2Gz7w","compact":"compact__3s3kh","dataTable":"dataTable__3ywzy"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/BriefGatewayData/styles.scss
// module id = 2259
// module chunks = 1